export const recipesRoutesPathPrefix = '/recipes';
export const createRecipeRoutesPath = '/create-recipe';
export const collectionsRoutesPathPrefix = '/collections';
export const translateRecipeRoutePath = '/translate/recipes';
export const translateCollectionRoutePath = '/translate/collections';
export const translateCategoryRoutePath = '/translate/categories';
export const translateFeatureRoutePath = '/translate/features';
